enum ClassifierGroup {
  WAREHOUSE = 'warehouse',
  CROP = 'crop',
  LIVESTOCK = 'livestock',
  FINANCE = 'finance',
  EQUIPMENT = 'equipment',
  HUMAN = 'human',
}

export default ClassifierGroup;
